import {Injectable} from '@angular/core';

import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';

import {Observable} from 'rxjs/Rx';
import 'rxjs/Rx';
import {environment} from '../../environments/environment';

@Injectable()
export class HttpService {

    constructor(private http: HttpClient, private router: Router) {
    }

    makeRequestPost(dataToSend: Array<any> = []) {

        var data = {};
        data = dataToSend[1];

        return this.http.post(environment.apiUrl + dataToSend[0], data)
        .map((response: any) => {
            // Some endpoints return the expiry with a 200 and the message in the body.
            if (response && this.isSessionExpired(response.error)) {
                this.logout();
            }
            return response;
        })
        .catch((error: any) => {
            // Others return a non-2xx; the message sits in the parsed error body.
            const message = error && error.error ? (error.error.error || error.error) : null;
            if (this.isSessionExpired(message)) {
                this.logout();
            }
            // Re-throw so each component's own error handling still runs.
            return Observable.throw(error);
        });
    }

    // True when the API tells us the admin's session is no longer valid.
    private isSessionExpired(message: any): boolean {
        return typeof message === 'string' && message.indexOf('Login session expired') > -1;
    }

    // Clear the stored session and send the admin back to the login screen.
    private logout() {
        localStorage.removeItem('Admin_User_Details');
        this.router.navigate(['/pages/login']);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/HttpService.ts